import { MutableValue } from "@/modules/api/mutable-value.interface";

export default class FactoryPlushieStatusQty implements MutableValue {
  public isNew = true;

  private fCreatedAt?: Date;
  private fUpdatedAt?: Date;

  constructor(
    private fId: string,
    private fFactory: string,
    private fPlushieStatus: string,
    private fPlushiesQty: number
  ) {
    [fId, fFactory, fPlushieStatus, fPlushiesQty].forEach((arg, index) => {
      if (arg === undefined) {
        throw new Error(`Undefined value passed at position: ${index}`);
      }
    });
  }

  get id(): string {
    return this.fId;
  }

  get factory(): string {
    return this.fFactory;
  }

  get plushieStatus(): string {
    return this.fPlushieStatus;
  }

  get plushiesQty(): number {
    return this.fPlushiesQty;
  }

  get createdAt(): Date | undefined {
    return this.fCreatedAt;
  }

  get updatedAt(): Date | undefined {
    return this.fUpdatedAt;
  }
}
